import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsIssueTypesAssociateRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-issue-types-associate',
	path: '/secure/admin/SelectIssueTypeSchemeForProject!default.jspa',
};
